import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 20,
  medium: 14,
  small: 12,
  xSmall: 9
};
const ShareIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.1746 11.0382L18.8254 10.2789L15.5 7.42857V7.37963H15.4429L15 7L14.5571 7.37963H14.5V7.42857L11.1746 10.2789L11.8254 11.0382L14.5 8.74604V18.3796H15.5V8.74604L18.1746 11.0382Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M11.5 14.8796V13.8796H8V22.8796H22V13.8796H18.5V14.8796H21V21.8796H9V14.8796H11.5Z", fill: "currentColor" })
  );
};
ShareIcon.iconName = "ShareIcon";

export { ShareIcon };
